// utils/generateSampleData.js
import * as XLSX from 'xlsx';

// Sample data for each Excel file
const samplePatients = [
  {
    id: '1',
    firstName: 'Aminata',
    lastName: 'Diallo',
    dateOfBirth: '1985-03-15',
    gender: 'F',
    phone: '+223 70 12 34 56',
    email: 'aminata.diallo@email.com',
    address: 'Bamako, Mali',
    emergencyContact: 'Moussa Diallo - +223 70 98 76 54',
    bloodType: 'O+',
    allergies: 'Pénicilline',
    medicalHistory: 'Hypertension',
    lifestyle: 'Non-fumeur, exercice régulier',
    createdBy: 'Dr. Diallo',
    createdAt: '2024-01-15T10:30:00.000Z',
    updatedBy: 'Dr. Diallo',
    updatedAt: '2024-01-15T10:30:00.000Z'
  },
  {
    id: '2',
    firstName: 'Ibrahim',
    lastName: 'Traoré',
    dateOfBirth: '1978-11-22',
    gender: 'M',
    phone: '+223 65 43 21 98',
    email: 'ibrahim.traore@email.com',
    address: 'Sikasso, Mali',
    emergencyContact: 'Fatoumata Traoré - +223 65 12 34 56',
    bloodType: 'A+',
    allergies: 'Aucune',
    medicalHistory: 'Diabète type 2',
    lifestyle: 'Fumeur occasionnel',
    createdBy: 'Dr. Diallo',
    createdAt: '2024-01-16T14:20:00.000Z',
    updatedBy: 'Dr. Diallo',
    updatedAt: '2024-01-16T14:20:00.000Z'
  }
];

const sampleConsultations = [
  {
    id: '1',
    patientId: '1',
    date: '2024-01-15',
    time: '10:30',
    motif: 'Contrôle tension artérielle',
    diagnostic: 'Hypertension contrôlée',
    examens: 'Tension: 130/80 mmHg, Pouls: 72 bpm',
    prescription: 'Amlodipine 5mg/jour',
    observations: 'Patient en bonne forme générale',
    nextAppointment: '2024-02-15',
    createdBy: 'Dr. Diallo',
    createdAt: '2024-01-15T10:30:00.000Z',
    updatedBy: 'Dr. Diallo',
    updatedAt: '2024-01-15T10:30:00.000Z'
  },
  {
    id: '2',
    patientId: '2',
    date: '2024-01-16',
    time: '14:20',
    motif: 'Suivi diabète',
    diagnostic: 'Diabète type 2 équilibré',
    examens: 'Glycémie: 1.2 g/L, HbA1c: 6.8%',
    prescription: 'Metformine 1000mg/jour',
    observations: 'Régime alimentaire respecté',
    nextAppointment: '2024-02-16',
    createdBy: 'Dr. Diallo',
    createdAt: '2024-01-16T14:20:00.000Z',
    updatedBy: 'Dr. Diallo',
    updatedAt: '2024-01-16T14:20:00.000Z'
  }
];

const sampleVitals = [
  {
    id: '1',
    patientId: '1',
    date: '2024-01-15',
    weight: 65,
    height: 165,
    bmi: 23.9,
    bloodPressure: '130/80',
    heartRate: 72,
    temperature: 36.5,
    respiratoryRate: 16,
    oxygenSaturation: 98,
    notes: 'Constantes normales',
    createdBy: 'Dr. Diallo',
    createdAt: '2024-01-15T10:30:00.000Z',
    updatedBy: 'Dr. Diallo',
    updatedAt: '2024-01-15T10:30:00.000Z'
  },
  {
    id: '2',
    patientId: '2',
    date: '2024-01-16',
    weight: 78,
    height: 175,
    bmi: 25.5,
    bloodPressure: '140/85',
    heartRate: 78,
    temperature: 36.8,
    respiratoryRate: 18,
    oxygenSaturation: 97,
    notes: 'Légère surcharge pondérale',
    createdBy: 'Dr. Diallo',
    createdAt: '2024-01-16T14:20:00.000Z',
    updatedBy: 'Dr. Diallo',
    updatedAt: '2024-01-16T14:20:00.000Z'
  }
];

const sampleTreatments = [
  {
    id: '1',
    patientId: '1',
    medication: 'Amlodipine',
    dosage: '5mg',
    frequency: '1 fois par jour',
    startDate: '2024-01-15',
    endDate: '2024-02-15',
    indication: 'Hypertension artérielle',
    adherence: 'Bonne',
    sideEffects: 'Aucun',
    notes: 'À prendre le matin',
    createdBy: 'Dr. Diallo',
    createdAt: '2024-01-15T10:30:00.000Z',
    updatedBy: 'Dr. Diallo',
    updatedAt: '2024-01-15T10:30:00.000Z'
  },
  {
    id: '2',
    patientId: '2',
    medication: 'Metformine',
    dosage: '1000mg',
    frequency: '2 fois par jour',
    startDate: '2024-01-16',
    endDate: '2024-02-16',
    indication: 'Diabète type 2',
    adherence: 'Très bonne',
    sideEffects: 'Légers troubles digestifs',
    notes: 'À prendre avec les repas',
    createdBy: 'Dr. Diallo',
    createdAt: '2024-01-16T14:20:00.000Z',
    updatedBy: 'Dr. Diallo',
    updatedAt: '2024-01-16T14:20:00.000Z'
  }
];

const sampleMedicalHistory = [
  {
    id: '1',
    patientId: '1',
    date: '2024-01-15',
    type: 'Antécédent familial',
    description: 'Père hypertendu',
    severity: 'Modéré',
    status: 'Actif',
    notes: 'Surveillance régulière recommandée',
    createdBy: 'Dr. Diallo',
    createdAt: '2024-01-15T10:30:00.000Z',
    updatedBy: 'Dr. Diallo',
    updatedAt: '2024-01-15T10:30:00.000Z'
  },
  {
    id: '2',
    patientId: '2',
    date: '2024-01-16',
    type: 'Antécédent personnel',
    description: 'Diabète type 2 diagnostiqué en 2020',
    severity: 'Modéré',
    status: 'Contrôlé',
    notes: 'Bien équilibré avec le traitement',
    createdBy: 'Dr. Diallo',
    createdAt: '2024-01-16T14:20:00.000Z',
    updatedBy: 'Dr. Diallo',
    updatedAt: '2024-01-16T14:20:00.000Z'
  }
];

const sampleObservations = [
  {
    id: '1',
    patientId: '1',
    date: '2024-01-15',
    type: 'Observation clinique',
    title: 'État général',
    description: 'Patient en bonne forme générale, pas de signes d\'alerte',
    priority: 'Normal',
    category: 'Examen clinique',
    notes: 'Continuer le suivi régulier',
    createdBy: 'Dr. Diallo',
    createdAt: '2024-01-15T10:30:00.000Z',
    updatedBy: 'Dr. Diallo',
    updatedAt: '2024-01-15T10:30:00.000Z'
  },
  {
    id: '2',
    patientId: '2',
    date: '2024-01-16',
    type: 'Recommandation',
    title: 'Régime alimentaire',
    description: 'Continuer le régime diabétique, éviter les sucres rapides',
    priority: 'Important',
    category: 'Éducation thérapeutique',
    notes: 'Patient motivé et compliant',
    createdBy: 'Dr. Diallo',
    createdAt: '2024-01-16T14:20:00.000Z',
    updatedBy: 'Dr. Diallo',
    updatedAt: '2024-01-16T14:20:00.000Z'
  }
];

// Function to create and download Excel files
export const generateSampleExcelFiles = () => {
  const files = [
    { name: 'Patients.xlsx', data: samplePatients },
    { name: 'Consultations.xlsx', data: sampleConsultations },
    { name: 'Constantes.xlsx', data: sampleVitals },
    { name: 'Traitements.xlsx', data: sampleTreatments },
    { name: 'Suivi.xlsx', data: sampleMedicalHistory },
    { name: 'Observations.xlsx', data: sampleObservations }
  ];

  files.forEach(({ name, data }) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
    XLSX.writeFile(workbook, name);
  });

  console.log('Sample Excel files generated successfully!');
};

// Function to initialize localStorage with sample data
export const initializeSampleData = () => {
  const sampleData = {
    patients: samplePatients,
    consultations: sampleConsultations,
    vitals: sampleVitals,
    treatments: sampleTreatments,
    medicalHistory: sampleMedicalHistory,
    observations: sampleObservations
  };

  localStorage.setItem('medical_platform_data', JSON.stringify(sampleData));
  console.log('Sample data initialized in localStorage!');
};

export default {
  generateSampleExcelFiles,
  initializeSampleData,
  samplePatients,
  sampleConsultations,
  sampleVitals,
  sampleTreatments,
  sampleMedicalHistory,
  sampleObservations
};
